import React, { Component, useRef } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faCheck } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import { CHAVE_EMPRESA, NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const estadoInicial = {
    name: '',
    ordens: [],
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
    status: 'Em Aberto',
    situacao: 'Todas',
    statusOptions: ['Todas', 'Em Aberto', 'Encerradas', 'Canceladas'],
    situacoesOptions: ['Todas']
}

class OrdensServicos extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getOrdens();
        this.getSituacoes();
    }

    getOrdens = async () => {
        apiEmployee.get(`pegarordensservicos?empresa=${this.props.empresa}`)
            .then(res => this.setState({
                ordens: res.data
            }))
    }

    getSituacoes = async () => {
        apiEmployee.get(`pegarsituacoes`)
            .then(res => this.setState({
                situacoesOptions: [...this.state.situacoesOptions, ...res.data.map((e) => e.Descricao)]
            }))
    }

    cancelOrdem = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja cancelar esta Ordem de Serviço? ({nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.delete(`cancelarordemservico/${id}`).then(
                                        async response => {
                                            if (response.data == true) {
                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    finishOrdem = (id, nome) => {
        apiEmployee.put(`atualizarordemservico/${id}`, { Encerrada: moment().format("YYYY-MM-DD") }).then(
            async response => {
                if (response.data == true) {
                    document.location.reload()
                }
            },
            async response => {
                this.erroApi(response)
            }
        )
    }

    filterItems = (item) => {
        if (this.state.status.toUpperCase() === 'EM ABERTO' && (item.Cancelada || moment(item.Encerrada).isValid())) {
            return false;
        } else if (this.state.status.toUpperCase() === 'CANCELADAS' && !item.Cancelada) {
            return false;
        } else if (this.state.status.toUpperCase() === 'ENCERRADAS' && !moment(item.Encerrada).isValid()) {
            return false;
        }

        if (this.state.situacao.toUpperCase() !== 'TODAS' && item.situacaoNome !== this.state.situacao) {
            return false;
        }

        return true;
    }



    render() {

        return (
            <div>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {!this.state.loading &&
                    <div>
                        <section>
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Ordens de Serviços</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>

                            <Link to={{
                                pathname: `/admin/addordemservico/0`,
                                state: { os: undefined }
                            }} className='butaoadicionarcardapio'> Adicionar Ordem de Serviço </Link>

                            <div className='butaofiltros' onClick={(a) => this.setState({ expandido: !this.state.expandido })}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div>

                        </div>

                        {this.state.expandido &&
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                                <div className='col-8' style={{display: 'flex', flexDirection:'row'}}>
                                    <div className='filter-field col-6 '>
                                        <span>Status:</span>
                                        <select className='select-filtro' value={this.state.status} onChange={(e) => this.setState({status: e.currentTarget.value})}>
                                        {this.state.statusOptions.map((opt) => (
                                            <option value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                    </div>
                                    <div className='filter-field col-6 '>
                                        <span>Situação:</span>
                                        <select className='select-filtro' value={this.state.situacao} onChange={(e) => this.setState({ situacao: e.currentTarget.value })}>
                                        {this.state.situacoesOptions.map((opt) => (
                                            <option value={opt}>{opt.toUpperCase()}</option>
                                        ))}
                                    </select>
                                    </div>
                                </div>
                            </div>
                        }

                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className='col-11 row'>
                                <div className='col-12 row arrumaraqui25'>
                                    <div className='col-2'>
                                        Número

                                    </div>
                                    <div className='col-3'>
                                        Defeito

                                    </div>

                                    <div className='col-3'>
                                        Situação

                                    </div>
                                    <div className='col-3'>
                                        Data

                                    </div>
                                    <div className='col-1'>


                                    </div>


                                </div>

                                {this.state.ordens.filter(this.filterItems).map((ordem, index) => {

                                    return (
                                        <div className={`col-12 row ${index % 2 == 0 ? 'arrumaraqui26' : 'arrumaraqui27'}`} key={ordem.Chave}>
                                            <Link className='col-2' to={{
                                                pathname: `/admin/addordemservico/${ordem.Chave}`,
                                                state: { os: { ...ordem } }
                                            }}>
                                                {ordem.Numero}

                                            </Link>
                                            <Link className='col-3' to={{
                                                pathname: `/admin/addordemservico/${ordem.Chave}`,
                                                state: { os: { ...ordem } }
                                            }}>
                                                {ordem.Defeito}

                                            </Link>

                                            <Link className='col-3' to={{
                                                pathname: `/admin/addordemservico/${ordem.Chave}`,
                                                state: { os: { ...ordem } }
                                            }}>
                                                {ordem.situacaoNome}

                                            </Link>

                                            <Link className='col-3' to={{
                                                pathname: `/admin/addordemservico/${ordem.Chave}`,
                                                state: { os: { ...ordem } }
                                            }}>
                                                {moment(ordem.Data).format('DD/MM/YYYY')}

                                            </Link>

                                            <div className='col-1 lixeira'>


                                                <FontAwesomeIcon title={"cancelar"} icon={faTimes} size="12" color={index % 2 == 0 ? "black" : "white"} onClick={() => this.cancelOrdem(ordem.Chave, ordem.Numero)} />


                                                <FontAwesomeIcon title={"encerrar"} icon={faCheck} size="12" color={index % 2 == 0 ? "black" : "white"} onClick={() => this.finishOrdem(ordem.Chave, ordem.Numero)} />

                                            </div>


                                        </div>
                                    )
                                })}









                            </div>
                        </div>

                    </div>
                }
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(OrdensServicos)
